<template>
  <div>
    <van-tabbar v-model="active">
      <van-tabbar-item
        v-for="(item, index) in items"
        :key="index"
        :name="item.key"
        @click="toPage(item)"
      >
        <template #icon>
          <img :src="require('@/assets/trade/'+item.key+'.png')" />
        </template>
        <span>{{ item.value }}</span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "TradeFooter",
  inject: ["app"],
  computed: {
    safeWapConfig() {
      return this.app.wapConfig || {};
    },
  },
  data() {
    return {
      active: 'home',
      items: [
        { key: "changemoney", value: this.$t("footer.change") },
        { key: "recharge", value: this.$t("footer.recharge") },
        { key: "withdrawal", value: this.$t("footer.withdrawal") },
      ],
    };
  },
  mounted(){
    this.active = this.$route.name
  },
  methods: {
    toPage(item) {
      if (item.key == "recharge" && this.safeWapConfig.recharge_status != 1) {
        if (this.safeWapConfig.custom_service.length > 0) {
          this.jumpUrl(this.safeWapConfig.custom_service);
          return;
        } else {
          this.$toast.fail(this.$t("common.forserver"));
          return;
        }
      } 
      if (item.key == "withdrawal" && this.safeWapConfig.withdrawal_status != 1) {
        if (this.safeWapConfig.custom_service.length > 0) {
          this.jumpUrl(this.safeWapConfig.custom_service);
          return;
        } else {
          this.$toast.fail(this.$t("common.forserver"));
          return;
        }
      } 
      this.$router.push({ name: item.key }, () => {});
    },
    jumpUrl(url) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
      /*
      const _u = navigator.userAgent;
      const ios = _u.indexOf("iPhone") > -1;
      const iPad = _u.indexOf("iPad") > -1;
      if (ios || iPad) {
        window.location.replace(url);
      } else {
        if (url.includes("https://")) {
          window.open(url);
        } else {
          window.location.href = url;
        }
      }
        */
    },
  },
};
</script>

<style>
</style>
